import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, parseISO } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '-';
  try {
    const date = typeof value === 'string' ? parseISO(value) : value;
    return format(date, 'MMM d, yyyy');
  } catch {
    return '-';
  }
}

export function formatDateFull(value: string | Date | null | undefined): string {
  if (!value) return '-';
  try {
    const date = typeof value === 'string' ? parseISO(value) : value;
    return format(date, 'MMMM d, yyyy');
  } catch {
    return '-';
  }
}

export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '-';
  try {
    const date = typeof value === 'string' ? parseISO(value) : value;
    return format(date, 'MMM d, yyyy h:mm a');
  } catch {
    return '-';
  }
}

export function formatDateTimeFull(value: string | Date | null | undefined): string {
  if (!value) return '-';
  try {
    const date = typeof value === 'string' ? parseISO(value) : value;
    return format(date, 'MMMM d, yyyy h:mm:ss a');
  } catch {
    return '-';
  }
}

export function formatCurrency(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '$0.00';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(num);
}

export function formatNumber(value: number | string | null | undefined, decimals = 0): string {
  if (value === null || value === undefined) return '0';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '0';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
}
